export const BORDER_RADIUSES = {
  medium: 'medium',
  small: 'small',
};
